import React, { useState, useEffect } from "react";
import Navigation from "../components/Navigation";
import AlterarDadosPessoais from "../components/forms/AlterarDadosPessoais";
import useAxios from "../helpers/useAxios";
import { useKeycloak } from "@react-keycloak/web";

const DadosPessoais = () => {
  const { keycloak } = useKeycloak();

  const [userData, SetUserData] = useState({});
  const [nif, setNif] = useState(
    getSessionNif()
  );

  function getSessionNif() {
    const stored = sessionStorage.getItem('nifAdmin');

    try 
    {
      if (stored)
      {
        return JSON.parse(stored);
      }
      else
      {
        return keycloak.tokenParsed.preferred_username;
      }
    }
    catch
    {
      return keycloak.tokenParsed.preferred_username;
    }
  }

  const { data, error, loaded } = useAxios("POST", "/User/user-detail", {
    nif: nif,
    email: keycloak.tokenParsed.email
  });

  useEffect(() => {
    if (loaded && error.length === 0){
      //data.bornDate = moment.tz(data.bornDate, "YYYY-MM-DD", 'UTC').format('DD-MM-YYYY')
      SetUserData(data)
    }
  }, [data]);

  return (
    <div className="container-fluid mt-4 mb-3">
      <div className="row gx-3"  style={{justifyContent: 'space-around'}}>
        <div className="col-md-2" style={{maxWidth:'250px'}}>
          <Navigation activeKey="/dadospessoais" />
        </div>
        <div className="col-md-10">
          <h1 className="mt-4">Outras opções</h1>
          <h2 className="mb-4">Dados pessoais</h2>
          <AlterarDadosPessoais userData={userData} />
        </div>
      </div>
   </div>
   );
};

export default DadosPessoais;
